<script setup lang="ts">
import { computed } from 'vue';
import { useQuasar } from 'quasar';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/stores/user';
import FsumNavButton from '@/components/Navigation/FsumNavButton.vue';
import FsumNavMenu from '@/components/Navigation/FsumNavMenu.vue';

/**
 * Responsive SideNav Height utilizing Quasar's screen size detection
 */
const $q = useQuasar();
const sideNavClasses = computed<string>(() => {
    const baseClasses = 'column justify-between no-wrap';
    return $q.screen.gt.sm ? `${baseClasses} full-height` : '';
});

const userStore = useUserStore();
const route = useRoute();
</script>
<template>
    <div
        :class="sideNavClasses"
    >
        <div
            role="region"
            class="full-width full-height"
            aria-label="navigation menu"
        >
            <FsumNavMenu :is-admin-center="true">
                <template #menu-items>
                    <FsumNavButton
                        role="menuitem"
                        label="Back to Flight School"
                        icon="arrow_back"
                        :to="{ name: 'default' }"
                    />
                    <q-separator />
                </template>
            </FsumNavMenu>
            <div class="nav-section-title q-pt-lg">
                Admin Center
            </div>
            <FsumNavButton
                label="School Directory"
                icon="school"
                red-indicator-location="left"
                :active="route.name === 'schoolDirectory'"
                :to="{ name: 'schoolDirectory' }"
            />
            <FsumNavButton
                v-if="userStore.isGlobalAdmin"
                label="Create a Flight School"
                icon="sym_o_add_box"
                red-indicator-location="left"
                :to="{ name: 'createSchool' }"
            />
            <FsumNavButton
                v-if="userStore.isGlobalAdmin"
                label="Lockout Report"
                icon="o_lock"
                red-indicator-location="left"
                :to="{ name: 'lockoutReport' }"
            />
            <div class="nav-section-title">
                Cross-Check
            </div>
            <FsumNavButton
                label="Back to Flight School"
                icon="arrow_back"
                :to="{ name: 'default' }"
            />
        </div>
    </div>
</template>
<style scoped>
.nav-section-title {
    font-size: 13px;
    font-weight: 500;
    color: var(--fsum-black);
}
</style>
